import React from 'react';
import Button from '../ui/Button';

const PortalPreview = () => {
  return (
    <section className="py-24 bg-slate-900 overflow-hidden">
      <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-100 mb-6">One Portal. All Your Courses.</h2>
          <p className="text-slate-400 text-lg mb-8">
            The LearnAnimated portal keeps everything in one place. Log in once and continue your journey from Class 5 to Class 12 without losing history.
          </p>
          <ul className="space-y-4 mb-8">
            {[
              "Track progress across science, math, and AI.",
              "Pick up exactly where you left off.",
              "Earn badges and certificates.",
              "Safe, distraction-free interface."
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-slate-300">
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-500"></span>
                {item}
              </li>
            ))}
          </ul>
          <Button variant="primary">See Portal Features</Button>
        </div>

        <div className="relative">
          {/* Mockup Container */}
          <div className="relative bg-slate-800 rounded-xl p-2 shadow-2xl border border-slate-700 transform md:rotate-1 hover:rotate-0 transition-transform duration-500">
            {/* Screen Content Mockup */}
            <div className="bg-slate-950 rounded-lg p-6 aspect-video flex flex-col gap-4 relative overflow-hidden">
               {/* Header Mock */}
               <div className="flex justify-between items-center border-b border-slate-800 pb-4">
                 <div className="w-24 h-4 bg-slate-800 rounded"></div>
                 <div className="flex gap-2">
                   <div className="w-8 h-8 rounded-full bg-cyan-900/50"></div>
                 </div>
               </div>
               {/* Body Mock */}
               <div className="flex gap-4 h-full">
                 <div className="w-1/4 bg-slate-900 rounded hidden sm:block"></div>
                 <div className="flex-1 bg-slate-900/50 rounded p-4">
                    <div className="w-1/2 h-6 bg-slate-800 rounded mb-4"></div>
                    <div className="w-full h-32 bg-slate-800/50 rounded mb-4 flex items-center justify-center text-slate-700">
                      <span className="text-4xl opacity-20">▶</span>
                    </div>
                    <div className="w-full h-2 bg-slate-800 rounded overflow-hidden">
                      <div className="w-2/3 h-full bg-cyan-500"></div>
                    </div>
                 </div>
               </div>
            </div>
          </div>
          {/* Glow Behind */}
          <div className="absolute -inset-4 bg-cyan-500/10 blur-2xl -z-10 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default PortalPreview;